import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

interface LocalizationMapping {
  name: string;
  locale: string;
  currency: Currency;
  countries: string[];
}

const localizationMapper = {
  'en-AU': {
    name: 'English - AU',
    locale: 'en-AU',
    currency: 'AUD',
    countries: ['AU'],
  },
  'en-NZ': {
    name: 'English - NZ',
    locale: 'en-NZ',
    currency: 'NZD',
    countries: ['NZ'],
  },
} satisfies Record<string, LocalizationMapping>;

export type Locale = keyof typeof localizationMapper;

const locales = Object.keys(localizationMapper) as Locale[];
const defaultLocale = locales[0] as Locale;

export const i18nConfig = {
  locales: locales,
  defaultLocale: locales[0],
};

export const getLocalizationInfo = (locale: string) => {
  if (!(locale in localizationMapper)) {
    console.warn(
      `Invalid locale ${locale} provided. Possible values are ${Object.keys(localizationMapper).join(', ')}`,
    );

    return localizationMapper[defaultLocale];
  }

  return localizationMapper[locale as keyof typeof localizationMapper];
};
